<template>
  <img src="../assets/icons/Spinner@1x-1.0s-200px-200px.svg" alt="loader gif" :width="size" :height="size">
</template>

<script>
export default {
  name: 'Loader',
  props: {
    size: {
      type: String,
      default: '24'
    },
  }
}
</script>